import { gql } from "@apollo/client";

export const ME = gql`
	query MeMyAccount {
		me {
			id
			name
			email
			avatar
			cpf
			phoneNumber
			coupon
			addressCity
			addressNeighborhood
			addressStreet
			addressNumber
			addressZipCode
			addressUF
		}
	}
`;

export const CREATE_REVIEW = gql`
	mutation RegisterReview($orderId: ID!, $rating: Int!, $description: String) {
		registerReview(orderId: $orderId, rating: $rating, description: $description) {
			success
			message
		}
	}
`;

export const MY_INDICATIONS = gql`
	query MyIndications {
		myIndications {
			userId
			status
			user {
				id
				name
			}
		}
	}
`;

export const ORDERS_LIST = gql`
	query OrdersList {
		orders {
			id
			pricePaid
			review {
				id
				rating
				description
			}
			classPrice {
				originalPrice
				finalPrice
				discount
			}
			class {
				id
				name
				description
				shift
				type
				numberOfInstallments
				period {
					id
					semester
					year
					active
				}
				courseInstitution {
					id
					duration
					durationType
				}
				campus {
					id
					name
					addressCity
				}
				course {
					id
					name
					description
					fieldOfStudy
					level
				}
				courseInstitution {
					id
					graduationType
					duration
					durationType
				}
				institution {
					id
					name
					description
					slug
					logo
				}
			}
			status
			boletoUrl
			boletoExpirationDate
		}
	}
`;

export const FETCH_USER_CPF = gql`
	mutation FetchUserCpf($cpf: String) {
		updateUser(cpf: $cpf) {
			success
			message
			user {
				id
				cpf
			}
		}
	}
`;

export const FETCH_CLASS = gql`
	query FetchClass($classId: ID!) {
		class(id: $classId) {
			id
			purchasePrice
		}
	}
`;

export const REMAKE_PAYMENT = gql`
	mutation remakePayment($orderData: OrderData!, $coupon: String) {
		payment(orderData: $orderData, coupon: $coupon) {
			success
			message
			order {
				id
				boletoBarcode
				boletoUrl
				pricePaid
				status
				class {
					id
					name
					purchasePrice
				}
			}
		}
	}
`;

export const UPDATE_CHECKOUT_STATUS = gql`
	mutation updateCheckoutStatus($isActive: Boolean!, $checkoutId: ID!) {
		updateCheckoutStatus(isActive: $isActive, checkoutId: $checkoutId) {
			success
			message
		}
	}
`;
